import { ReduceStore } from 'flux/utils';
import Dispatcher from '../dispatcher';
import ACTION_TYPES from '../constants/action_types';
import { FSRemoveLightBoxActions } from '../constants/fs_remove_light_box/fs_remove_light_box_actions';

class FSRemoveLightBoxStoreClass extends ReduceStore {
    getInitialState() {
        return {
            visible: false,
            expanded: false,
            invalid: false,
            invalidMessage: '',
        };
    }

    reduce(state, { source, action }) {
        if (source === ACTION_TYPES.FS_REMOVE_LIGHTBOX_ACTION) {
            switch (action.type) {
                case FSRemoveLightBoxActions.SHOW:
                    if (!state.visible) {
                        state.visible = true;
                        state.invalid = false;
                        state.invalidMessage = '';
                        this.__emitChange();
                    }

                    break;

                case FSRemoveLightBoxActions.HIDE:
                    if (state.visible) {
                        state.visible = false;
                        state.invalid = false;
                        state.invalidMessage = '';
                        this.__emitChange();
                    }

                    break;

                case FSRemoveLightBoxActions.EXPAND:
                    if (!state.expanded) {
                        state.expanded = true;
                        this.__emitChange();
                    }

                    break;

                case FSRemoveLightBoxActions.FS_REMOVE_INVALID_ACTION:
                    if (!state.invalid) {
                        state.invalid = true;
                        state.invalidMessage = action.payload;
                        this.__emitChange();
                    }
                    break;
            }
        }

        return state;
    }
}

const FSRemoveLightBoxStore = new FSRemoveLightBoxStoreClass(Dispatcher);
export { FSRemoveLightBoxStore };
